/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 26.07.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Classnames from 'classnames';

import DivLoader from '../../../components/DivLoader';
import Translate from '../../../components/Translate';

import {SetSettingsState} from '../../../actions/common/actions-common';
import {Registration} from '../../../actions/auth/actions-auth';

class RegistrationTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
      tabId: null,
      formDataUser: '',
      formDataPassword: '',
      formDataPassword2: '',
      formDataFirstName: '',
      formDataLastName: ''
    };
  }

  componentDidMount() {
    document.getElementById('user_login_settings') && document.getElementById('user_login_settings').focus();

    document.getElementById('dummy_submit') && document.getElementById('dummy_submit').addEventListener('focus', function (e) {

      document.getElementById('user_login_settings') && document.getElementById('user_login_settings').focus();
    }, true);
  }

  componentDidUpdate(prevProps) {

    if (prevProps.user.user !== this.props.user && this.props.user.user !== 'guest') {
      setTimeout(() => {

        this.props.SetSettingsState({
          isShown: false,
          tabId: null
        });
      }, 350);
    }
  }

  componentWillReceiveProps(newProps) {

    let state = {};

    if (newProps.isError) {
      document.getElementById('user_login_settings') && document.getElementById('user_login_settings').focus();
    }

    state.isError = newProps.isError;
    state.errorMsg = newProps.errorMsg;

    this.setState(state);
  }

  _onUserChange(event) {

    this.setState({formDataUser: event.target.value});
  }


  _onPasswordChange(event) {

    this.setState({formDataPassword: event.target.value});
  }


  _onPasswordChange2(event) {

    this.setState({formDataPassword2: event.target.value});
  }


  _onFirstNameChange(event) {

    this.setState({formDataFirstName: event.target.value});
  }


  _onLastNameChange(event) {

    this.setState({formDataLastName: event.target.value});
  }

  _onSubmit(event) {
    event.preventDefault && event.preventDefault();

    if (!this.state.formDataUser) {

      this.setState({
        isError: true,
        errorMsg: 'username field empty'
      });

      return;
    }

    if (!this.state.formDataPassword) {

      this.setState({
        isError: true,
        errorMsg: 'password field empty'
      });

      return;
    }

    if (this.state.formDataPassword !== this.state.formDataPassword2) {

      this.setState({
        isError: true,
        errorMsg: 'passwords mismatch'
      });

      return;
    }

    this.props.Registration(this.state.formDataUser, this.state.formDataPassword, this.state.formDataFirstName, this.state.formDataLastName);
  }

  _isLogin() {

    return this.props.user.user !== 'guest';
  }

  render() {
    if (this._isLogin()) {

      return (<div className="settings-col">
        <p className="mt">
          <Translate content="settings.tabs.registration.success" />
        </p>
      </div>);
    }

    if (this.props.needConfirmation) {

      return (<div className="settings-col">
        <p className="mt">
          <Translate content="settings.tabs.registration.need_confirmation" />
        </p>
      </div>);
    }

    const userLoginClass = Classnames({
      'error-field': this.state.isError && this.state.errorMsg === 'already exist' || this.state.errorMsg === 'username field empty',
      'auth-field': true
    });

    const userPasswordClass = Classnames({
      'error-field': this.state.isError && this.state.errorMsg === 'password field empty',
      'auth-field': true
    });

    const userPassword2Class = Classnames({
      'error-field': this.state.isError && this.state.errorMsg === 'passwords mismatch',
      'auth-field': true
    });

    return (<div className="relative">
      <DivLoader loading={this.props.inProgress} />
      <form id="regForm" className="js-form" role="form" onSubmit={this._onSubmit.bind(this)}>
        <div className="settings-col" style={{verticalAlign: 'top'}}>
          <label htmlFor="user_login_settings"> <Translate content="settings.tabs.registration.email" /> </label>
          <input id="user_login_settings" name="username" type="text" className={userLoginClass} tabIndex="1"
                 value={this.state.formDataUser} onChange={this._onUserChange.bind(this)} />
          <label htmlFor="user_password"> <Translate content="settings.tabs.registration.password" /> </label>
          <input id="user_password" name="password" type="password" className={userPasswordClass} tabIndex="2"
                 value={this.state.formDataPassword} onChange={this._onPasswordChange.bind(this)} />
          <label htmlFor="user_firstname_settings"> <Translate content="settings.tabs.registration.first_name" /> </label>
          <input id="user_firstname_settings" name="firstname" type="text" className="auth-field" tabIndex="4"
                 value={this.state.formDataFirstName} onChange={this._onFirstNameChange.bind(this)} />
        </div>
        <div className="settings-col" style={{marginTop: '55px', verticalAlign: 'top'}}>
          <label htmlFor="user_password2"> <Translate content="settings.tabs.registration.password2" /> </label>
          <input id="user_password2" name="password2" type="password" className={userPassword2Class} tabIndex="3"
                 value={this.state.formDataPassword2} onChange={this._onPasswordChange2.bind(this)} />
          <label htmlFor="user_lastname_settings"> <Translate content="settings.tabs.registration.last_name" /> </label>
          <input id="user_lastname_settings" name="lastname" type="text" className="auth-field" tabIndex="6"
                 value={this.state.formDataLastName} onChange={this._onLastNameChange.bind(this)} />
          <a className="btn-dark authorization" href="javascript:void(0)" onClick={this._onSubmit.bind(this)}> <Translate content="settings.tabs.registration.sign_up" /> </a>
        </div>
        <input id="dummy_submit" type="text" style={{height: 0, width: 0, opacity: 0, display: 'block', float: 'left'}} tabIndex="7" />
        <button type="submit" style={{height: 0, opacity: 0, visibility: 'hidden'}} tabIndex="4">Submit</button>
      </form>
      {this.state.isError && <div className="reg-error-message" style={{position: 'absolute', top: '15px', right: '50px'}}>
        <em> <Translate content={`error.${this.state.errorMsg}`} /> </em>
      </div>}
    </div>);
  }
}

RegistrationTab.propTypes = {
  user: PropTypes.object,
  isError: PropTypes.bool,
  inProgress: PropTypes.bool,
  errorMsg: PropTypes.string,
  needConfirmation: PropTypes.bool,
  settings: PropTypes.object
};

const mapStateToProps = ({auth: {user, registration: {isError, inProgress, errorMsg, needConfirmation}}, common: {settings}}) => {

  return {user, isError, inProgress, errorMsg, needConfirmation, settings};
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({SetSettingsState, Registration}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationTab);



// WEBPACK FOOTER //
// ./src/containers/Settings/Tabs/registration.js